import React, { useState } from "react";
import { IfPermitted, Timestamp, LinkContainer } from "components/common";
import SearchLink from "views/logic/search/SearchLink";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
import { Button, BootstrapModalConfirm, ButtonToolbar } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useDataLakeRetrievalMutation from "../hooks/useDataLakeRetrievalMutation";
const DataLakeRetrievalActions = ({ retrieval }) => {
  var _a;
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { onDeleteDataLakeRetrievalOperationMutation } = useDataLakeRetrievalMutation();
  const sendTelemetry = useSendTelemetry();
  const onConfirmDelete = () => {
    onDeleteDataLakeRetrievalOperationMutation({
      streamId: retrieval == null ? void 0 : retrieval.stream_id,
      retrievalOperationId: retrieval == null ? void 0 : retrieval.id
    });
  };
  const handleDelete = (event) => {
    event.stopPropagation();
    setShowConfirmDelete(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.RETRIEVALS.DELETE_RETRIEVAL_CLICKED, {});
  };
  const getIndicesQueryString = (restoreIndices) => restoreIndices.reduce((acc, indice, currentIndex, arr) => {
    if (currentIndex + 1 === arr.length) {
      return `${acc}_index:${indice.index_name}`;
    }
    return `${acc}_index:${indice.index_name} OR `;
  }, "");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showConfirmDelete && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showConfirmDelete,
      onConfirm: () => onConfirmDelete(),
      onCancel: () => setShowConfirmDelete(false),
      title: "Are you sure?"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "You are about to delete retrieved messages from", " ", /* @__PURE__ */ React.createElement("b", null, /* @__PURE__ */ React.createElement(Timestamp, { dateTime: retrieval == null ? void 0 : retrieval.retrieved_at })), ". This will delete ", /* @__PURE__ */ React.createElement("b", null, (_a = retrieval == null ? void 0 : retrieval.restore_indices) == null ? void 0 : _a.length), " indices."), /* @__PURE__ */ React.createElement("p", null, "Do you want to continue?"))
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, { className: "pull-right" }, /* @__PURE__ */ React.createElement(
    LinkContainer,
    {
      to: SearchLink.builder().query(createElasticsearchQueryString(getIndicesQueryString(retrieval == null ? void 0 : retrieval.restore_indices))).timerange({
        type: "absolute",
        from: retrieval == null ? void 0 : retrieval.timestamp_from,
        to: retrieval == null ? void 0 : retrieval.timestamp_to
      }).build().toURL()
    },
    /* @__PURE__ */ React.createElement(
      Button,
      {
        bsSize: "xsmall",
        onClick: () => {
          sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.RETRIEVALS.SHOW_MESSAGES_BUTTON_CLICKED, {});
        }
      },
      "Show messages"
    )
  ), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["data_lake_archive:delete"] }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: "danger", onClick: handleDelete }, "Delete"))));
};
export default DataLakeRetrievalActions;
